import React, { useMemo } from "react";
import {
  Button,
  Icon,
  Paragraph,
  breakpoints,
  useColorTokens,
  useMediaQuery
} from "@tvg/design-system";
import { Container } from "./styled-components";

interface ActionButtonsProps {
  onClickPromo: () => void;
  onClickWatchReplay: () => void;
  hasReplay?: boolean;
  hasPromo?: boolean;
  isOptedIn?: boolean;
  isMultileg?: boolean;
}

const ActionButtons = ({
  onClickPromo,
  onClickWatchReplay,
  hasReplay,
  hasPromo,
  isOptedIn,
  isMultileg
}: ActionButtonsProps) => {
  const colorTokens = useColorTokens();
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);

  const buttonSize = useMemo(() => {
    if (isMultileg && !isMobile && (hasPromo || hasReplay)) {
      return "s";
    }
    return isMobile || isMultileg ? "m" : "l";
  }, [isMobile, isMultileg, hasPromo, hasReplay]);

  return (
    <Container data-qa-label="action-buttons-container">
      {hasPromo && (
        <Button
          qaLabel={isOptedIn ? "promo-button-opt-in" : "promo-button"}
          variant={isOptedIn ? "secondary" : "marketing"}
          onPress={onClickPromo}
          size={buttonSize}
          width={1}
        >
          <>
            <Icon
              name="promo"
              size="s"
              mr="space-3"
              lineColor={colorTokens.content[isOptedIn ? "positive" : "alert"]}
              backgroundColor={
                colorTokens.background[
                  isOptedIn ? "positiveSubtle" : "alertSubtle"
                ]
              }
            />
            <Paragraph
              qaLabel="promo-button-text"
              fontFamily="medium"
              fontSize={isMultileg && !isMobile ? "xs" : "s"}
            >
              Promo
            </Paragraph>
          </>
        </Button>
      )}
      {hasReplay && (
        <Button
          qaLabel="watch-replay-button"
          variant="secondary"
          onPress={onClickWatchReplay}
          icon="replay"
          iconPosition="start"
          size={buttonSize}
          width={1}
        >
          Watch Replay
        </Button>
      )}
    </Container>
  );
};

export default ActionButtons;
